import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

// for using different app (different schema of database), when using client methods, input your url start with /map or /connectUp
// i.e. client.get('/map/places')
export const BASE_URL = '/api'

const instance = axios.create({
  baseURL: BASE_URL,
})

function getCookie(name: string) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    const shiftedValue = parts.pop()?.split(';').shift()
    return shiftedValue ?? null
  }
}
instance.interceptors.request.use((config) => {
  const token = getCookie('csrftoken')
  if (token) {
    config.headers['X-CSRFToken'] = token
  }
  return config
})

export const client = {
  delete: <ResponseType>(url: string) => {
    const opts: AxiosRequestConfig<never> = {
      headers: { 'Content-Type': 'application/json' },
      method: 'delete',
      url: url,
      withCredentials: true,
    }
    return instance.request<ResponseType, AxiosResponse<ResponseType>, never>(opts)
  },
  get: <ResponseType>(url: string, params?: Record<string, string>) => {
    const opts: AxiosRequestConfig<never> = {
      headers: { 'Content-Type': 'application/json' },
      method: 'get',
      ...(params ? { params } : {}),
      url: url,
      withCredentials: true,
    }
    return instance.request<ResponseType, AxiosResponse<ResponseType>, never>(opts)
  },
  post<ResponseType, RequestDataType extends JSON>(
    url: string,
    data?: RequestDataType,
    params?: JSON
  ) {
    const opts: AxiosRequestConfig<RequestDataType> = {
      data,
      headers: { 'Content-Type': 'application/json' },
      method: 'post',
      ...(params ? { params } : {}),
      url: url,
      withCredentials: true,
    }
    return instance.request<ResponseType>(opts)
  },
  put<ResponseType, RequestDataType extends JSON>(
    url: string,
    data: RequestDataType,
    params?: JSON
  ) {
    const opts: AxiosRequestConfig<RequestDataType> = {
      data,
      headers: { 'Content-Type': 'application/json' },
      method: 'put',
      ...(params ? { params } : {}),
      url: url,
      withCredentials: true,
    }
    return instance.request<ResponseType>(opts)
  },
  patch<ResponseType, RequestDataType extends JSON>(
    url: string,
    data: RequestDataType,
    params?: JSON
  ) {
    const opts: AxiosRequestConfig<RequestDataType> = {
      data,
      headers: { 'Content-Type': 'application/json' },
      method: 'patch',
      ...(params ? { params } : {}),
      url: url,
      withCredentials: true,
    }
    return instance.request<ResponseType>(opts)
  },
  uploadFile: <ResponseType>(url: string, file: File) => {
    const formData = new FormData()
    formData.append('avatar', file)
    const opts: AxiosRequestConfig = {
      method: 'post',
      url: url,
      data: formData,
      withCredentials: true,
    }
    return instance.request<ResponseType>(opts)
  },
  multipart: <ResponseType>(url: string, formData: FormData) => {
    const opts: AxiosRequestConfig = {
      method: 'post',
      url: url,
      data: formData,
      withCredentials: true,
    }
    return instance.request<ResponseType>(opts)
  },
}
